<template>
  <div class="Option">
    <div class="page-title" v-if="is_goods">{{ title }}</div>
    <div>
      <ATable
        ref="table"
        max-height="780px"
        :placeholder="placeholder"
        :search_field="search_field"
        :data="items"
        :disable_insert="!has_grant_write"
        hideButtonExcel
        hide-pagination
        border
        @row-click="handleClickRow"
        @clicked-create="handleClickedCreate"
      >
        <div slot="search" class="inline">
          <div class="inline">
            <el-select
              v-model="search_class_flag"
              size="mini"
              style="width: 100px"
              :placeholder="$t('lang.sales_classification')"
            >
              <el-option :key="null" :value="null" label="전체" />
              <el-option key="1" value="1" label="사양" />
              <el-option key="2" value="2" label="비고" />
            </el-select>
          </div>
        </div>
        <el-table-column
          type="index"
          :label="$t('lang.No')"
          align="center"
          :width="$width.index"
        />
        <el-table-column prop="name" label="이름" width="200" />
        <el-table-column
          prop="class_flag"
          label="구분"
          width="50"
          :formatter="resolveClassFlag"
        />
        <el-table-column
          prop="price"
          label="가격"
          width="70"
          class-name="cell-number"
          :formatter="util.numberFormat"
        />
        <el-table-column prop="desc" label="비고" />
        <el-table-column
          prop="created_user_name"
          :label="$t('lang.created_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="modified_user_name"
          :label="$t('lang.modified_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="created_at"
          :label="$t('lang.created_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="modified_at"
          :label="$t('lang.modified_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
      </ATable>
    </div>
    <el-dialog
      custom-class="option-form-dialog"
      :style="{ width: 1200 }"
      top="0"
      :title="title"
      destroyOnClose
      :visible.sync="dialog_visible"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      @opened="handleOpened"
    >
      <OptionForm
        ref="form"
        v-if="dialog_visible"
        :kind="kind"
        :data="form_data"
        :has_grant_write="has_grant_write"
        @completed="handleCompleted"
      />
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { form_container } from "@/common/mixins/form_container";
import { authority_level } from "@/common/mixins/authority_level";
import OptionForm from "./OptionForm";

export default {
  name: "Option",
  mixins: [form_container, authority_level],
  components: { OptionForm },
  data() {
    return {
      placeholder: "이름, 비고",
      search_field: ["name", "desc"],
      search_class_flag: null,
      dialog_visible: false,
      form_data: undefined,
    };
  },
  props: {
    kind: {
      type: String,
      default: "GOODS",
    },
  },
  computed: {
    ...mapGetters(["table_option"]),
    items() {
      return this.table_option.filter((o) => {
        return (
          o.product_kind === this.kind &&
          (this.search_class_flag
            ? o.class_flag === this.search_class_flag
            : true)
        );
      });
    },
    has_grant_write() {
      return this.isWriteLevel("option");
    },
    is_goods() {
      return this.kind === "GOODS";
    },
    title() {
      return this.is_goods
        ? this.$t("title.goods_option")
        : this.$t("title.option");
    },
  },
  methods: {
    resolveClassFlag(row, column, value) {
      return value === "2" ? "비고" : "사양";
    },
    /** 다이얼로그 팝업 */
    openDialog(data) {
      let clone = undefined;
      if (data) {
        clone = this.util.clone(data);
      }
      this.form_data = clone;
      this.dialog_visible = true;
    },
    /** 데이터 선택 */
    handleClickRow(data) {
      this.openDialog(data);
    },
    handleClickedCreate() {
      this.openDialog();
    },
    /**  폼 처리 완료 */
    handleCompleted() {
      this.dialog_visible = false;
    },
  },
};
</script>
<style lang="scss">
.option-form-dialog {
  width: 1200px;
  height: auto;
}
</style>
